import { Form, Formik } from 'formik';
import { Modal } from 'app/shared/components/modals/Modal';
import { IStepReason } from '../../../../interfaces';
import { ReasonsModalForm } from './ReasonsModalForm';

export interface ReasonsValues {
  [key: string]: boolean;
}

interface IReasonsTableModalProps {
  handleClose: () => void;
  handleSubmit: (reasons: ReasonsValues) => void;
  currentReasons: IStepReason[];
  matchedReasons: IStepReason[];
  loading: boolean;
  reasonModalPosition: number;
}

export const ReasonsModal = ({
  handleSubmit,
  currentReasons,
  handleClose,
  matchedReasons,
  reasonModalPosition,
  loading,
}: IReasonsTableModalProps) => {
  const initialReasonsState: ReasonsValues = currentReasons.reduce((acc: ReasonsValues, item: IStepReason) => {
    acc[item.label] = item.isResolved;
    return acc;
  }, {});

  return (
    <Modal
      open
      hideBackdrop
      title="Reasons for next step"
      dialogWidth="500px"
      resetPosition={reasonModalPosition}
      isLoading={loading}
      onClose={handleClose}
    >
      <Formik 
        enableReinitialize 
        initialValues={initialReasonsState as ReasonsValues} 
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <ReasonsModalForm
              handleClose={handleClose}
              currentReasons={currentReasons}
              matchedReasons={matchedReasons}
              {...props}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
